// extracted by mini-css-extract-plugin
module.exports = {"container":"FormGroup_container__Zl_ug","withoutBorder":"FormGroup_withoutBorder__1ZP86","sending":"FormGroup_sending__1DZ_H"};